var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"team_member_container"},[_c('div',{staticClass:"inner"},_vm._l((JSON.parse(_vm.team_members)),function(member,index){return _c('team-member',{key:index,attrs:{"name":member.name,"permalink":member.permalink,"position":member.position,"background":member.background}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/leonaudio.stagingwebsite.dev/web/app/themes/texture/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/leonaudio.stagingwebsite.dev/web/app/themes/texture/node_modules/vue-loader/lib?{}!./scripts/vue/TeamMemberContainer.vue?vue&type=template&id=11f77df5&scoped=true&
// module id = 94
// module chunks = 0